import React, { useState } from "react";
import PropTypes from "prop-types";
import { DialogTitle, DialogContent, Typography, Box, Button, Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VpnKeyIcon from "@mui/icons-material/VpnKey";

function ScriptForm({ campaign }) {
  const [copiedApi, setCopiedApi] = useState(false);
  const [copiedToken, setCopiedToken] = useState(false);

  if (!campaign) return null;

  // 👀 UI me dikhne wala code (placeholder only)

  const script = `
  fetch("https://dialer.thedialgo.com/public/api/campaign/data", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      campaign_id: "#"
      api_token: "PASTE_CAMPAIGN_TOKEN_HERE",
      phone: "9999******",
      email: "test@demo.com"
    })
  });
  `.trim();

  const copyApiMethod = async () => {
    await navigator.clipboard.writeText(script);
    setCopiedApi(true);
    setTimeout(() => setCopiedApi(false), 2000);
  };

  const copyToken = async () => {
    await navigator.clipboard.writeText(campaign.token || "");
    setCopiedToken(true);
    setTimeout(() => setCopiedToken(false), 2000);
  };

  return (
    <>
      <DialogTitle sx={{ textAlign: "center" }}>
        <Typography variant="h5" fontWeight={600}>
          Campaign API
        </Typography>
      </DialogTitle>

      <DialogContent>
        {/* 🔑 Copy Token Button */}
        <Stack direction="row" justifyContent="center" mb={2}>
          <Button
            variant="outlined"
            startIcon={<VpnKeyIcon />}
            onClick={copyToken}
            sx={{
              px: 3,
              fontWeight: 600,
              color: copiedToken ? "#16a34a" : "#2563eb",
              borderColor: copiedToken ? "#16a34a" : "#2563eb",
              backgroundColor: copiedToken ? "#ecfdf5" : "transparent",
              "&:hover": {
                backgroundColor: copiedToken ? "#dcfce7" : "#eff6ff",
                borderColor: copiedToken ? "#15803d" : "#1d4ed8",
              },
            }}
          >
            {copiedToken ? "Token Copied ✅" : "Copy API Token"}
          </Button>
        </Stack>

        {/* 📄 API Code */}
        <Box
          sx={{
            backgroundColor: "#020617",
            color: "#e5e7eb",
            p: 2.5,
            borderRadius: 2,
            fontFamily: "JetBrains Mono, monospace",
            fontSize: 13,
            whiteSpace: "pre-wrap",
            maxHeight: 320,
            overflow: "auto",
            border: "1px solid #1e293b",
          }}
        >
          {script}
        </Box>

        {/* 📋 Copy API Method */}
        <Stack direction="row" justifyContent="center" mt={2}>
          <Button
            variant="contained"
            startIcon={<ContentCopyIcon />}
            onClick={copyApiMethod}
            sx={{
              px: 4,
              py: 1.2,
              fontWeight: 600,
              borderRadius: 2,
              color: "#fff",
              background: copiedApi
                ? "linear-gradient(135deg, #16a34a, #15803d)"
                : "linear-gradient(135deg, #2563eb, #1d4ed8)",
              "&:hover": {
                background: copiedApi
                  ? "linear-gradient(135deg, #15803d, #166534)"
                  : "linear-gradient(135deg, #1d4ed8, #1e40af)",
              },
            }}
          >
            {copiedApi ? "Copied ✅" : "Copy API Method"}
          </Button>
        </Stack>
      </DialogContent>
    </>
  );
}

ScriptForm.propTypes = {
  campaign: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    token: PropTypes.string,
  }),
};

export default ScriptForm;
